export default __webpack_public_path__ + "static/media/cricketball.770ae3ed.png";